// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const hoothoot: PokeData = {
  "id": 163,
  "name": "hoothoot",
  "height": 7,
  "weight": 212,
  "base_experience": 52,
  "types": [
    PokeType.NORMAL,
    PokeType.FLYING
  ],
  "api_moves": [
    "tackle",
    "take-down",
    "growl",
    "peck",
    "confusion",
    "hypnosis",
    "reflect",
    "dream-eater",
    "foresight",
    "uproar",
    "extrasensory",
    "roost",
    "psycho-shift",
    "air-slash",
    "zen-headbutt",
    "defog",
    "synchronoise",
    "echoed-voice",
    "moonblast"
  ],
  "moves": [
    "tackle",
    "growl",
    "peck",
    "reflect",
    "roost",
    "air-slash",
    "zen-headbutt",
    "moonblast",
    "body-slam",
    "purification",
    "brave-bird",
    "headbutt",
    "hurricane"
  ],
  "evolution_chain": {
    "id": 83,
    "item": null,
    "species": [
      {
        "name": "hoothoot",
        "order": 195,
        "types": [
          PokeType.NORMAL,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "noctowl",
        "order": 196,
        "types": [
          PokeType.NORMAL,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 163,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 51.5,
    "speed": 50,
    "ability_power": 36
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
